export enum BackupTransactionType {
  All = 'all',
  BankPayment = 'bankPayment',
  Bill = 'bill',
  ExternalInvoice = 'externalInvoice',
  Invoice = 'invoice',
}
